import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
} from 'reactstrap'
import moment from '../../../lib/moment.js'
import DatePicker from 'react-datepicker'
import { FONTS, COLORS } from '../../../constants'

export const ExportLeaveHistory = class extends React.Component {
  state={
    start_date: moment()
      .subtract(7, 'days')
      .utcOffset(0)
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
    end_date: moment()
      .utcOffset(0)
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
  }

  export = () => {
    const access_token = localStorage.getItem('access_token')
    this.props.exportLeaveHistory(
      moment(this.state.start_date).format('YYYY-MM-DD'),
      moment(this.state.end_date).format('YYYY-MM-DD'),
      access_token
    )
    this.props.toggle()
  }

  render() {
    const { open, toggle } = this.props

    return (
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <ModalHeader
          toggle={ () => toggle() }
        >
          <HeadLabel>Export</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Text>Select Date</Text>
          <DatePickerWrapper>
            <ExportDatePicker
              autoComplete='off'
              onChange={ (e) => this.setState({ start_date: e }) }
              placeholderText='DD/MM/YYYY'
              selected={ this.state.start_date }
              dateFormat="DD/MM/YYYY"
              showYearDropdown
              showMonthDropdown
            />
            &nbsp;-&nbsp;
            <ExportDatePicker
              autoComplete='off'
              onChange={ (e) => this.setState({ end_date: e }) }
              placeholderText='DD/MM/YYYY'
              selected={ this.state.end_date }
              dateFormat="DD/MM/YYYY"
              showYearDropdown
              showMonthDropdown
            />
          </DatePickerWrapper>
        </ModalBody>
        <ModalFooter>
          <ExportButton
            color="success"
            onClick={ () => this.export() }
          >Export</ExportButton>
        </ModalFooter>
      </Modal>
    )
  }
}

ExportLeaveHistory.propTypes = {
  exportLeaveHistory: PropTypes.func,
  toggle: PropTypes.func,
  open: PropTypes.bool,
}
ExportLeaveHistory.defaultProps = {
  exportLeaveHistory: () => {},
  toggle: () => {},
  open: false,
}

const Text = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const ExportButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const DatePickerWrapper = styled.div`
  display: flex;
  align-items: center;
`
const ExportDatePicker = styled(DatePicker)`
  font-family: 'Gotham' !important;
  width: 200px;
  @media only screen and (max-width: 1440px) {
    width: 200px;
  }
  @media only screen and (max-width: 1024px) {
    width: 150px;
  }
  height : 45px ;
  font-size: 12px ;
  padding-left: 5%;
  float: right;
  border-radius: 5px;
  margin-left: 10%;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
`
const HeadLabel = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`



// WEBPACK FOOTER //
// ./src/components/report/form/export-leave-history.js